<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-kemu-copy"></i>
      成绩统计
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">

          <el-input
              v-model="stu_name"
              placeholder="请输入姓名"
              class="margin-right-sm"
          ></el-input>
          <el-input
              v-model="stu_idCard"
              placeholder="请输入身份证号"
              class="margin-right-sm"
          ></el-input>
          <el-select v-model="state" placeholder="请选择状态" class="margin-right-sm" v-if="paper!==1">
            <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
        <div class="felx align-center">
          <el-button type="primary" size="small" @click="subdialogDialog = true" v-if="paper!==1">
            <p class="flex align-center font-size">
              {{ scoreForm.base > 0 ? '获证率:' + scoreForm.base + '%' : '设置获证率' }}
            </p>
          </el-button>
          <el-button type="primary" size="small" @click="releaseResults" v-if="stuList.length>0">
            <p class="flex align-center font-size">
              发布成绩
            </p>
          </el-button>
          <el-button type="primary" size="small" @click="importResults" v-if="stuList.length>0">
            <p class="flex align-center font-size">
              导入基础成绩
            </p>
          </el-button>
          <br>
          <el-button type="primary" size="small" class="margin-top-xs" @click="certification()" v-if="paper!==1 && scoreForm.base>0">
            <p class="flex align-center font-size">
              发证
            </p>
          </el-button>
          <el-button type="primary" size="small" class="margin-top-xs" @click="exportList" v-if="stuList.length>0">
            <p class="flex align-center font-size">
              导出成绩单
            </p>
          </el-button>
          <el-button type="primary" size="small" class="margin-top-xs" @click="exportFile" v-if="stuList.length>0">
            <p class="flex align-center font-size">
              导出附件
            </p>
          </el-button>
        </div>
      </div>
      <el-table
          :data="stuList"
          header-row-class-name="table-header"
          alig="center"
          :row-class-name="tableRowClassName"
          fit
          style="width: 100%"
      >

        <el-table-column label="排名" type="index">
          <template slot-scope="scope">
            <div class="table-item">
              {{( page-1) * 10 + scope.$index +1}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.sex }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="身份证号码">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.idcard }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="考点">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.exam_address }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="准考证号">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.student_exam_number }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="基础知识">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.question_base_grade }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="实践案例">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.question_practice_grade }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="综合成绩">
          <template slot-scope="scope">
            <div class="table-item">
              {{ scope.row.question_synthetical_grade }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="获证状态">
          <template slot-scope="scope">
            <div class="table-item">
              <span v-if=" Number(scope.row.cert_state) === 2">已获得</span>
              <span v-else-if=" Number(scope.row.cert_state) === 1">基础考试已通过</span>
              <span v-else-if=" Number(scope.row.cert_state) === 0">未审核</span>
              <span v-else>拒绝</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="380">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button v-if=" Number(scope.row.cert_state) === 0 "
                         size="medium"
                         type="primary"
                         @click="certification(scope.row.student_id)"
              >通过
              </el-button>
              <router-link :to="'/projectOffice/examBasicStatistics?exam='+exam_id+'&id='+ scope.row.student_id"
                           class="margin-left-xs">
                <el-button
                    size="medium"
                    type="primary"
                >基础得分统计
                </el-button>
              </router-link>
              <router-link :to="'/projectOffice/examCaseStatistics?exam='+exam_id+'&id='+ scope.row.student_id"
                           v-if="paper!==1"
                           class="margin-left-xs">
                <el-button
                    size="medium"
                    type="danger"
                >案例得分统计
                </el-button>
              </router-link>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="stuList.length > 0"
          class="page-all"
          background
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
        title="获证率设置"
        :visible.sync="subdialogDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="scoreForm" :rules="rules" ref="scoreForm" label-width="100px">
        <el-form-item label="获证率" prop="setbase">
          <el-input type="number" v-model="scoreForm.setbase" placeholder="请输入获证率%"></el-input>
        </el-form-item>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="subdialogDialog = false">取消</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitForm('scoreForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  studentScoreList,
  setCertPercent,
  pushScore,
  issueCert,
  doExportStudent,
  doGetBaseScore, doDownloadZip
} from "@/api/projectOffice";

export default {
  name: "examStatistics",
  data() {
    return {

      paper: 0,
      stuList: [],
      page: 1,
      total: 0,
      limit: 10,
      stu_name: '',
      stu_idCard: '',
      state: 0,
      stateList: [
        {label: '全部', value: 0},
        {label: '通过', value: 1},
        {label: '未通过', value: -1},
      ],
      scoreForm: {
        base: '',
        setbase:''
      },
      rules: {
        setbase: [{required: true, message: '请输入获证率', trigger: 'blur'},],
      },
      subdialogDialog: false,
      exam_id: '',
      pass:-1,
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/examination',
        "当前位置：考试管理 > 成绩统计",
        true
    );
    this.exam_id = this.$route.query.id
    this.paper = Number(this.$route.query.paper)
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page), this.stu_name = this.$route.query.stu_name, this.stu_idcard = this.$route.query.stu_idcard, this.state = Number(this.$route.query.state)
    }
    this.getList()
    this.getCertPercent()
  },
  methods: {

    async getList() {
      let _list = await studentScoreList(this.$route.query.id, this.page, this.limit, this.state, this.stu_name, this.stu_idCard)
      this.stuList = _list.data.list
      this.total = _list.data.count
      this.pass = _list.data.cert_num
    },
    tableRowClassName({row, rowIndex}) {
      console.log(this.pass)
      if (this.pass>0 && rowIndex === (this.pass % 10) && ((this.page-1)*10 + this.pass % 10 === this.pass) ) {
        return 'success-row';
      }else{
        return '';
      }

    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/projectOffice/examStatistics',
        query: {
          id: this.$route.query.id,
          page: this.page,
          state: this.state,
          stu_name: this.stu_name,
          stu_idCard: this.stu_idCard,
          paper: this.paper
        }
      })
    },
    onSearch() {
      if (this.page === 1) {
        this.setPath()
      } else {
        this.page = 1;
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setCertPercent(formName)
        }
      });
    },
    async getCertPercent() {
      let _data = await setCertPercent(1, '', this.$route.query.id)
      this.scoreForm.base = Number(_data.data.rate)
      this.scoreForm.setbase = Number(_data.data.rate)
    },
    async setCertPercent() {
      let _data = await setCertPercent(2, this.scoreForm.setbase, this.$route.query.id)
      this.$message.success(_data.msg)
      this.subdialogDialog = false
      this.getCertPercent()
    },

    //  导入成绩
    importResults(){
      this.$confirm("确定要给未签到的考试导入基础成绩吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.importScore();
      });
    },
    async importScore() {
      let _state = await doGetBaseScore(this.$route.query.id)
      this.$message.success(_state.msg)
      await this.getList()
    },

    //  发布成绩
    releaseResults() {
      this.$confirm("确定要发布成绩吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.pushScore();
      });
    },
    async pushScore() {
      let _state = await pushScore(this.$route.query.id)
      this.$message.success(_state.msg)
      await this.getList()
    },

    //  发证
    certification(sut = '') {
      this.$confirm(this.paper === 1 ? '确定要通过基础考试吗？' : "确定要发布证书吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.pushCertification(sut);
      });
    },
    async pushCertification(sut) {
      let _state = await issueCert(this.$route.query.id, sut)
      this.$message.success(_state.msg)
      this.getList()
    },
    async exportList() {
      let _data = await doExportStudent(this.$route.query.id)
      let blob = _data.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', this.$route.query.name + '成绩单' + '.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    async exportFile() {
      let _data = await doDownloadZip(this.$route.query.id)
      this.$message.info('导出数据中，请稍后')
      var downloadElement = document.createElement('a');
      var href =_data.data
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.target = '_blank';
      // downloadElement.setAttribute('download', this.$route.query.name + '成绩单' + '.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },

  },
  watch: {
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    },
    subdialogDialog(){
      this.scoreForm.setbase =this.scoreForm.base
    }
  }
}
</script>

<style scoped lang="scss">

</style>
